import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/common/routes/requireAuth";
import DocbuilderController from "@/pages/organizations/detail/builder";

export const Route = createFileRoute("/app/organizations/$organizationId/builder")({
  beforeLoad: ({ context }) => {
    requireAuth(context);
  },
  component: DocbuilderController,
});
